export interface CountryOption {
  code: string;
  name: string;
}

export const COUNTRIES: CountryOption[] = [
  { code: "af", name: "Afeganistão" },
  { code: "za", name: "África do Sul" },
  { code: "al", name: "Albânia" },
  { code: "de", name: "Alemanha" },
  { code: "ad", name: "Andorra" },
  { code: "ao", name: "Angola" },
  { code: "ai", name: "Anguilla" },
  { code: "ag", name: "Antígua e Barbuda" },
  { code: "sa", name: "Arábia Saudita" },
  { code: "dz", name: "Argélia" },
  { code: "ar", name: "Argentina" },
  { code: "am", name: "Armênia" },
  { code: "aw", name: "Aruba" },
  { code: "au", name: "Austrália" },
  { code: "at", name: "Áustria" },
  { code: "az", name: "Azerbaijão" },
  { code: "bs", name: "Bahamas" },
  { code: "bh", name: "Bahrein" },
  { code: "bd", name: "Bangladesh" },
  { code: "bb", name: "Barbados" },
  { code: "be", name: "Bélgica" },
  { code: "bz", name: "Belize" },
  { code: "bj", name: "Benim" },
  { code: "bm", name: "Bermudas" },
  { code: "by", name: "Bielorrússia" },
  { code: "bo", name: "Bolívia" },
  { code: "ba", name: "Bósnia e Herzegovina" },
  { code: "bw", name: "Botswana" },
  { code: "br", name: "Brasil" },
  { code: "bn", name: "Brunei" },
  { code: "bg", name: "Bulgária" },
  { code: "bf", name: "Burkina Faso" },
  { code: "bi", name: "Burundi" },
  { code: "bt", name: "Butão" },
  { code: "cv", name: "Cabo Verde" },
  { code: "cm", name: "Camarões" },
  { code: "kh", name: "Camboja" },
  { code: "ca", name: "Canadá" },
  { code: "kz", name: "Cazaquistão" },
  { code: "td", name: "Chade" },
  { code: "cl", name: "Chile" },
  { code: "cn", name: "China" },
  { code: "cy", name: "Chipre" },
  { code: "co", name: "Colômbia" },
  { code: "km", name: "Comores" },
  { code: "cg", name: "República do Congo" },
  { code: "kp", name: "Coreia do Norte" },
  { code: "kr", name: "Coreia do Sul" },
  { code: "ci", name: "Costa do Marfim" },
  { code: "cr", name: "Costa Rica" },
  { code: "hr", name: "Croácia" },
  { code: "cu", name: "Cuba" },
  { code: "dk", name: "Dinamarca" },
  { code: "dj", name: "Djibouti" },
  { code: "dm", name: "Dominica" },
  { code: "eg", name: "Egito" },
  { code: "sv", name: "El Salvador" },
  { code: "ae", name: "Emirados Árabes" },
  { code: "ec", name: "Equador" },
  { code: "er", name: "Eritreia" },
  { code: "sk", name: "Eslováquia" },
  { code: "si", name: "Eslovênia" },
  { code: "es", name: "Espanha" },
  { code: "fm", name: "Estados Federados da Micronésia" },
  { code: "us", name: "Estados Unidos" },
  { code: "ee", name: "Estónia" },
  { code: "et", name: "Etiópia" },
  { code: "fj", name: "Fiji" },
  { code: "ph", name: "Filipinas" },
  { code: "fi", name: "Finlândia" },
  { code: "fr", name: "França" },
  { code: "ga", name: "Gabão" },
  { code: "gm", name: "Gâmbia" },
  { code: "gh", name: "Gana" },
  { code: "ge", name: "Geórgia" },
  { code: "gd", name: "Granada" },
  { code: "gr", name: "Grécia" },
  { code: "gp", name: "Guadalupe" },
  { code: "gu", name: "Guam" },
  { code: "gt", name: "Guatemala" },
  { code: "gy", name: "Guiana" },
  { code: "gf", name: "Guiana Francesa" },
  { code: "gn", name: "Guiné" },
  { code: "gq", name: "Guiné Equatorial" },
  { code: "gw", name: "Guiné-Bissau" },
  { code: "ht", name: "Haiti" },
  { code: "hn", name: "Honduras" },
  { code: "hk", name: "Hong Kong" },
  { code: "hu", name: "Hungria" },
  { code: "ye", name: "Iêmen" },
  { code: "ky", name: "Ilhas Cayman" },
  { code: "ck", name: "Ilhas Cook" },
  { code: "fo", name: "Ilhas Feroé" },
  { code: "sb", name: "Ilhas Salomão" },
  { code: "vi", name: "Ilhas Virgens Americanas" },
  { code: "vg", name: "Ilhas Virgens Britânicas" },
  { code: "in", name: "Índia" },
  { code: "id", name: "Indonésia" },
  { code: "gb", name: "Reino Unido" },
  { code: "ir", name: "Irão" },
  { code: "iq", name: "Iraque" },
  { code: "ie", name: "Irlanda" },
  { code: "is", name: "Islândia" },
  { code: "il", name: "Israel" },
  { code: "it", name: "Itália" },
  { code: "jm", name: "Jamaica" },
  { code: "jp", name: "Japão" },
  { code: "jo", name: "Jordânia" },
  { code: "ki", name: "Kiribati" },
  { code: "xk", name: "Kosovo" },
  { code: "kw", name: "Kuwait" },
  { code: "la", name: "Laos" },
  { code: "ls", name: "Lesoto" },
  { code: "lv", name: "Letônia" },
  { code: "lb", name: "Líbano" },
  { code: "lr", name: "Libéria" },
  { code: "ly", name: "Líbia" },
  { code: "li", name: "Liechtenstein" },
  { code: "lt", name: "Lituânia" },
  { code: "lu", name: "Luxemburgo" },
  { code: "mo", name: "Macau" },
  { code: "mk", name: "Macedônia do Norte" },
  { code: "mg", name: "Madagáscar" },
  { code: "my", name: "Malásia" },
  { code: "mw", name: "Malawi" },
  { code: "mv", name: "Maldivas" },
  { code: "ml", name: "Mali" },
  { code: "mt", name: "Malta" },
  { code: "ma", name: "Marrocos" },
  { code: "mq", name: "Martinica" },
  { code: "mu", name: "Maurícia" },
  { code: "mr", name: "Mauritânia" },
  { code: "mx", name: "México" },
  { code: "mm", name: "Mianmar" },
  { code: "mz", name: "Moçambique" },
  { code: "md", name: "Moldávia" },
  { code: "mc", name: "Mónaco" },
  { code: "mn", name: "Mongólia" },
  { code: "me", name: "Montenegro" },
  { code: "ms", name: "Montserrat" },
  { code: "na", name: "Namíbia" },
  { code: "nr", name: "Nauru" },
  { code: "np", name: "Nepal" },
  { code: "ni", name: "Nicarágua" },
  { code: "ne", name: "Níger" },
  { code: "ng", name: "Nigéria" },
  { code: "no", name: "Noruega" },
  { code: "nc", name: "Nova Caledônia" },
  { code: "nz", name: "Nova Zelândia" },
  { code: "om", name: "Omã" },
  { code: "nl", name: "Países Baixos" },
  { code: "pw", name: "Palau" },
  { code: "ps", name: "Palestina" },
  { code: "pa", name: "Panamá" },
  { code: "pg", name: "Papua-Nova Guiné" },
  { code: "pk", name: "Paquistão" },
  { code: "py", name: "Paraguai" },
  { code: "pe", name: "Peru" },
  { code: "pf", name: "Polinésia Francesa" },
  { code: "pl", name: "Polónia" },
  { code: "pr", name: "Porto Rico" },
  { code: "pt", name: "Portugal" },
  { code: "qa", name: "Catar" },
  { code: "ke", name: "Quênia" },
  { code: "kg", name: "Quirguistão" },
  { code: "cf", name: "República Centro-Africana" },
  { code: "cz", name: "República Checa" },
  { code: "tw", name: "Taiwan" },
  { code: "cd", name: "República Democrática do Congo" },
  { code: "do", name: "República Dominicana" },
  { code: "ro", name: "Roménia" },
  { code: "rw", name: "Ruanda" },
  { code: "ru", name: "Rússia" },
  { code: "mf", name: "São Martinho" },
  { code: "ws", name: "Samoa" },
  { code: "as", name: "Samoa Americana" },
  { code: "lc", name: "Santa Lúcia" },
  { code: "kn", name: "São Cristóvão e Névis" },
  { code: "sm", name: "San Marino" },
  { code: "st", name: "São Tomé e Príncipe" },
  { code: "vc", name: "São Vicente e Granadinas" },
  { code: "sn", name: "Senegal" },
  { code: "sl", name: "Serra Leoa" },
  { code: "rs", name: "Sérvia" },
  { code: "sc", name: "Seicheles" },
  { code: "sg", name: "Singapura" },
  { code: "sx", name: "São Martinho (Sint Maarten)" },
  { code: "sy", name: "Síria" },
  { code: "so", name: "Somália" },
  { code: "lk", name: "Sri Lanka" },
  { code: "sz", name: "Suazilândia" },
  { code: "sd", name: "Sudão" },
  { code: "ss", name: "Sudão do Sul" },
  { code: "se", name: "Suécia" },
  { code: "ch", name: "Suíça" },
  { code: "sr", name: "Suriname" },
  { code: "tj", name: "Tajiquistão" },
  { code: "th", name: "Tailândia" },
  { code: "tz", name: "Tanzânia" },
  { code: "tl", name: "Timor-Leste" },
  { code: "tg", name: "Togo" },
  { code: "to", name: "Tonga" },
  { code: "tt", name: "Trinidad e Tobago" },
  { code: "tn", name: "Tunísia" },
  { code: "tc", name: "Turks e Caicos" },
  { code: "tm", name: "Turquemenistão" },
  { code: "tr", name: "Turquia" },
  { code: "tv", name: "Tuvalu" },
  { code: "ua", name: "Ucrânia" },
  { code: "ug", name: "Uganda" },
  { code: "uy", name: "Uruguai" },
  { code: "uz", name: "Uzbequistão" },
  { code: "vu", name: "Vanuatu" },
  { code: "va", name: "Vaticano" },
  { code: "ve", name: "Venezuela" },
  { code: "vn", name: "Vietnã" },
  { code: "zm", name: "Zâmbia" },
  { code: "zw", name: "Zimbabwe" },
];
